/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchUpdateTimecardEnforcementSettingsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {BatchUpdateTimecardEnforcementSettingsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const batchUpdateTimecardEnforcementSettings = (request: BatchUpdateTimecardEnforcementSettingsRequest, options?: CashRequestOptions) => post<BatchUpdateTimecardEnforcementSettingsRequest, BatchUpdateTimecardEnforcementSettingsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/BatchUpdateTimecardEnforcementSettings", request, {...options, rejectOnError: true })